import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export type EvaluationTeamMemberType = {
  id: string | null;
  uiUuid?: string | null;
  teamMemberName: string | null;
  teamMemberId: string | null;
  teamMemberDiscipline: string | null;
};

export type HealthSummaryType = {
  id: string | null;
  eligibilityDateEvaluation: string | null;
  eligibilityEvaluationResultComment: string | null;
  healthHistoryComment: string | null;
  currentHealthComment: string | null;
  additionalInformationComment: string | null;
  sessionReviewedDate: string | null;
  evaluationTeamMembers: EvaluationTeamMemberType[];
};

export type IfspHealthSummaryReportType = {
  ifspId: string | null;
  healthSummary: HealthSummaryType[];
  heldBy: string | null;
  isCurrentlyHeld: boolean;
  latestEvaluationDate: string | null;
};

export type IfspReportHealthSummaryTypeStateType = {
  originalIfspHealthSummaryReport: IfspHealthSummaryReportType;
  ifspHealthSummaryReport: IfspHealthSummaryReportType;
};

export const initialIfspHealthSummaryReportState: IfspReportHealthSummaryTypeStateType =
  {
    originalIfspHealthSummaryReport: {
      ifspId: null,
      healthSummary: [],
      heldBy: null,
      isCurrentlyHeld: false,
      latestEvaluationDate: null,
    },
    ifspHealthSummaryReport: {
      ifspId: null,
      healthSummary: [],
      heldBy: null,
      isCurrentlyHeld: false,
      latestEvaluationDate: null,
    },
  };

const ifspHealthSummarySlice = createSlice({
  name: 'ifspHealthSummaryReport',
  initialState: initialIfspHealthSummaryReportState,
  reducers: {
    setIfspHealthSummaryReport: (
      state,
      action: PayloadAction<IfspHealthSummaryReportType>,
    ) => {
      state.ifspHealthSummaryReport = action.payload;
      state.originalIfspHealthSummaryReport = action.payload;
    },
    updateIfspHealthSummaryReport: (
      state,
      action: PayloadAction<Partial<IfspHealthSummaryReportType>>,
    ) => {
      state.ifspHealthSummaryReport = {
        ...state.ifspHealthSummaryReport,
        ...action.payload,
      };
    },
    updateOriginalIfspHealthSummaryReport: (
      state,
      action: PayloadAction<Partial<IfspHealthSummaryReportType>>,
    ) => {
      state.originalIfspHealthSummaryReport = {
        ...state.originalIfspHealthSummaryReport,
        ...action.payload,
      };
    },

    resetIfspHealthSummaryReport: () => initialIfspHealthSummaryReportState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialIfspHealthSummaryReportState,
    );
  },
});

export const {
  setIfspHealthSummaryReport,
  updateIfspHealthSummaryReport,
  updateOriginalIfspHealthSummaryReport,
  resetIfspHealthSummaryReport,
} = ifspHealthSummarySlice.actions;

export default ifspHealthSummarySlice.reducer;
